const genId = (() => {
  let id = -1;
  return () => {
    id += 1;
    return id;
  };
})();
const works = {
  data: [
    {
      id: genId(),
      title: '你所不知道的必學前端 Debug 技巧',
      description:
        '改編自 iT邦幫忙鐵人賽冠軍系列文章《你所不知道的各種前端Debug技巧》。一本可精進你的 Debug 技巧，讓你從有效率的解決問題到避免問題發生的前端 Debug 技巧工具書！',
      source: 'github',
      imgUrl: 'https://i.imgur.com/T0IY5Vl.png',
      url: 'https://www.tenlong.com.tw/products/9789864348954',
      date: '2021',
      objectFit: 'contain',
    },
    {
      id: genId(),
      title: 'PDF Editor',
      description:
        '快速線上編輯 PDF 的首選，不用上傳檔案確保隱私，手機也可以使用哦～',
      source: 'github',
      imgUrl: 'https://i.imgur.com/8TmmQ0X.png',
      url: 'https://pdf-editor.now.sh',
      date: '2020',
      objectFit: 'contain',
    },
    {
      id: genId(),
      title: 'KTV 搜歌吧',
      description:
        '找歌、找詞、建立歌單，去 KTV 從此不怕沒歌唱！趕快加到手機主畫面試試看。',
      source: 'private',
      imgUrl: 'https://i.imgur.com/2fiS6zQ.png',
      url: 'https://sh1zuku.app/ktv/',
      date: '2020',
      objectFit: 'contain',
    },
    {
      id: genId(),
      title: 'WinXP',
      description:
        '還記得踩地雷、小畫家、Winamp 嗎？網頁版 Windows XP 讓你找回最初的感動！',
      source: 'github',
      imgUrl: 'https://i.imgur.com/C8PyNJq.jpg',
      url: 'https://winxp.now.sh',
      date: '2019',
      objectFit: 'cover',
    },
    {
      id: genId(),
      title: 'Fake Screen',
      description: '各式各樣的惡作劇畫面，拿來當螢幕保護程式也不錯。',
      source: 'github',
      imgUrl: 'https://i.imgur.com/dbKTf7y.png',
      url: 'https://screen.now.sh',
      date: '2019',
      objectFit: 'cover',
    },
    {
      id: genId(),
      title: 'Dungeons',
      description: '文字風格勇者鬥惡龍，隨機地圖和自動打怪 (r) 真的太療癒啦！',
      source: 'github',
      imgUrl: 'https://i.imgur.com/ibA52h0.png',
      url: 'https://dungeons.now.sh',
      date: '2019',
      objectFit: 'cover',
    },
    {
      id: genId(),
      title: 'Windows XP Minesweeper',
      description: '攜帶版踩地雷，走到哪踩到哪。',
      source: 'github',
      imgUrl: 'https://i.imgur.com/GTZzLOt.png',
      url: 'https://mines.now.sh',
      date: '2019',
      objectFit: 'cover',
    },
    {
      id: genId(),
      title: 'Doge Dodge 閃子彈遊戲',
      description: '你能夠達到第幾關？歡迎來挑戰。',
      source: 'github',
      imgUrl: 'https://i.imgur.com/j4PQHao.png',
      url: 'http://dog.csie.io',
      date: '2018',
      objectFit: 'cover',
    },

    {
      id: genId(),
      title: 'Birthday',
      description: '壽星專屬，網頁小遊戲。',
      source: 'github',
      imgUrl: 'https://i.imgur.com/9uzBY3P.png',
      url: 'https://sh1zuku.csie.io/birthday',
      date: '2018',
      objectFit: 'cover',
    },
    {
      id: genId(),
      title: 'Todo List',
      description: '不簡單的待辦清單',
      source: 'github',
      imgUrl: 'https://i.imgur.com/lCSqkCP.png',
      url: 'https://sh1zuku.csie.io/todo',
      date: '2018',
      objectFit: 'cover',
    },
    {
      id: genId(),
      title: 'BrainFuck.js 線上直譯器',
      description: '支援逐步、多步執行，輕鬆 Debug',
      source: 'github',
      imgUrl: 'https://i.imgur.com/wNyjAMT.png',
      url: 'https://sh1zuku.csie.io/BrainFuck-Interpreter.js/',
      date: '2018',
      objectFit: 'cover',
    },
  ],
};

export default works;



// WEBPACK FOOTER //
// ./src/Components/Works/works.js